import { render, staticRenderFns } from "./MsgRecord.vue?vue&type=template&id=129d4542"
import script from "./MsgRecord.vue?vue&type=script&lang=js"
export * from "./MsgRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports